module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-spend-01-b49b86eb3ae7a3989ac5eab89c348ddd.png";